import React, { useState } from 'react';
import Card from '../../ui/Card';
import Modal from '../../ui/Modal';
import Button from '../../ui/Button';
import { QuoteIcon } from '../../ui/Icons';

export default function SgMessageSection({ teamData = [] }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const sgMember = teamData.find((m) => m.role === "Secrétaire Général");

  const fullMotParagraphs = [
    "« C'est avec un immense honneur, une profonde fierté et un grand sens des responsabilités que j'assume la fonction de Secrétaire Général de l'Association des Comoriens Étudiants au Maroc (ACEM), Section Régionale de Fès.",
    "La confiance qui m'a été accordée constitue, avant tout, un engagement. Un engagement à œuvrer avec détermination, intégrité et dévouement afin de répondre aux responsabilités qui me sont confiées. Avec l'ensemble des membres du bureau qui m'accompagnent, nous partageons une ambition commune : fédérer les Comoriens autour d'un projet collectif fondé sur l'unité, la solidarité, l'innovation et le sens du service.",
    "Notre action sera guidée par la mise en œuvre rigoureuse de notre plan d'action annuel. Nous nous investirons avec cœur, rigueur et persévérance afin d'atteindre les objectifs que nous nous sommes fixés, dans l'intérêt de notre communauté.",
    "Ma vision est claire : notre engagement ne connaît aucune distinction. Qu'il soit étudiant, stagiaire, travailleur, visiteur ou présent au Maroc pour des raisons médicales ou toute autre circonstance, tout citoyen comorien mérite considération, écoute et accompagnement. Dès lors qu'il porte la nationalité comorienne, je me sentirai toujours investi du devoir moral de défendre ses intérêts, avec une attention particulière envers celles et ceux qui pourraient être marginalisés en raison de leur statut.",
    "Je veillerai également à ce que notre association soit administrée avec responsabilité, transparence et rigueur, en assurant une gestion saine de nos ressources humaines, matérielles, immatérielles et financières. La confiance de notre communauté est un patrimoine précieux que nous avons le devoir de préserver.",
    "Enfin, j'adresse mes vœux de réussite à l'ensemble des étudiants comoriens et lance un appel à tous les Comoriens résidant à Fès. Engageons-nous résolument au service de notre communauté. Rassemblons nos compétences, nos énergies et nos convictions pour défendre les causes qui nous unissent et bâtir ensemble une communauté toujours plus forte, plus solidaire et tournée vers l'avenir.",
    "Ensemble, faisons de l'ACEM-Fès une institution exemplaire, au service de tous. »"
  ];

  return (
    <>
      <Card variant="glass" className="h-full w-full p-6 sm:p-8 relative overflow-hidden flex flex-col justify-between text-center shadow-acem-md hover:shadow-acem-lg transition-shadow">
        {/* Glow backdrop */}
        <div className="absolute top-0 right-0 w-40 h-40 bg-acem-primary/10 rounded-full filter blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-40 h-40 bg-acem-accent/10 rounded-full filter blur-3xl pointer-events-none" />

        <div className="space-y-3">
          <div className="flex items-center justify-between border-b border-acem-border/50 pb-3">
            <h2 className="font-title text-xl sm:text-2xl font-extrabold text-acem-primary-dark tracking-tight text-left">
              Mot du Secrétaire Général
            </h2>
            <div className="w-9 h-9 bg-acem-primary/10 text-acem-primary rounded-full flex items-center justify-center flex-shrink-0">
              <QuoteIcon className="w-4 h-4" />
            </div>
          </div>

          {/* Aperçu des premiers paragraphes */}
          <div className="text-xs sm:text-sm text-left text-acem-text/85 leading-relaxed space-y-2.5">
            <p className="m-0 line-clamp-3">{fullMotParagraphs[0]}</p>
            <p className="m-0 line-clamp-3">
              {fullMotParagraphs[1]}
            </p>
          </div>
        </div>

        {/* Signature du SG & Bouton d'ouverture de la boîte de dialogue */}
        <div className="flex items-center justify-between gap-3.5 pt-4 mt-6 border-t border-acem-border/60 w-full flex-wrap">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-full overflow-hidden border-2 border-acem-primary bg-acem-surface flex-shrink-0 shadow-sm relative">
              <img
                src="/bureau_acem_fes/Secrétaire général/image.jpeg"
                alt={sgMember?.name || "Secrétaire Général"}
                className="w-full h-full object-cover object-[center_5%]"
                onError={(e) => {
                  const encodedGitHub = "https://raw.githubusercontent.com/acemfes/acem-fes-media-assets/main/bureau_acem_fes/Secr%C3%A9taire%20g%C3%A9n%C3%A9ral/image.jpeg";
                  if (e.currentTarget.src !== encodedGitHub && sgMember?.photoUrl) {
                    e.currentTarget.src = sgMember.photoUrl;
                  } else if (e.currentTarget.src !== encodedGitHub) {
                    e.currentTarget.src = encodedGitHub;
                  } else {
                    e.currentTarget.style.display = 'none';
                  }
                }}
              />
            </div>
            <div className="text-left">
              <strong className="block text-acem-text font-bold text-xs sm:text-sm">
                {sgMember?.name || "Le Bureau ACEM Fès"}
              </strong>
              <span className="text-[11px] text-acem-muted font-medium">Secrétaire Général</span>
            </div>
          </div>

          <Button
            onClick={() => setIsModalOpen(true)}
            variant="primary"
            size="sm"
            className="shadow-sm"
          >
            Voir la suite
          </Button>
        </div>
      </Card>

      {/* Boîte de dialogue (Modal) pour la lecture de l'intégralité du discours */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Mot du Secrétaire Général"
        maxWidth="max-w-3xl"
      >
        <div className="space-y-6 p-1">
          {/* Header SG avec photo et titre dans la modale */}
          <div className="flex items-center gap-4 bg-acem-surface-container-low p-4 sm:p-5 rounded-[16px] border border-acem-border">
            <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full overflow-hidden border-2 border-acem-primary bg-acem-surface flex-shrink-0 shadow-md relative">
              <img
                src="/bureau_acem_fes/Secrétaire général/image.jpeg"
                alt={sgMember?.name || "Secrétaire Général"}
                className="w-full h-full object-cover object-[center_5%]"
                onError={(e) => {
                  const encodedGitHub = "https://raw.githubusercontent.com/acemfes/acem-fes-media-assets/main/bureau_acem_fes/Secr%C3%A9taire%20g%C3%A9n%C3%A9ral/image.jpeg";
                  if (e.currentTarget.src !== encodedGitHub && sgMember?.photoUrl) {
                    e.currentTarget.src = sgMember.photoUrl;
                  } else if (e.currentTarget.src !== encodedGitHub) {
                    e.currentTarget.src = encodedGitHub;
                  } else {
                    e.currentTarget.style.display = 'none';
                  }
                }}
              />
            </div>
            <div>
              <h4 className="font-title font-extrabold text-base sm:text-lg text-acem-primary-dark">
                {sgMember?.name || "Secrétaire Général - ACEM Fès"}
              </h4>
              <p className="text-xs sm:text-sm text-acem-muted font-medium">
                Message officiel adressé à la communauté estudiantine et aux Comoriens de Fès
              </p>
            </div>
          </div>

          {/* Discours Intégral en paragraphes bien lisibles */}
          <div className="space-y-4 text-acem-text/90 leading-relaxed text-sm sm:text-base text-justify font-normal">
            {fullMotParagraphs.map((paragraph, idx) => (
              <p key={idx} className="m-0">
                {paragraph}
              </p>
            ))}
          </div>

          {/* Pied de la modale */}
          <div className="pt-4 border-t border-acem-border/60 flex items-center justify-between flex-wrap gap-3">
            <span className="font-title font-bold text-acem-primary text-xs sm:text-sm">
              ACEM Fès — Égalité • Solidarité • Excellence
            </span>
            <Button
              onClick={() => setIsModalOpen(false)}
              variant="primary"
              size="sm"
            >
              Fermer
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
